import script from "./PlAppHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PlAppHeader.vue?vue&type=script&setup=true&lang=js"

import "./PlAppHeader.vue?vue&type=style&index=0&id=a433b2dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a433b2dc"]])

export default __exports__